module.exports = __webpack_public_path__ + "static/media/fichaIA.fa61d760.png";